import { ATTRIBUTION_REFERRAL_URL } from '../../../constants';

export const attributionContent = (
  attribution: string,
  track: string,
  artist: string,
  shortId: string,
  referralURL: string
) => {
  /** This section will be eliminated once linkFire begins to arrive directly from the data rather than being extracted by us from attribution."  */
  const urlRegex = /(https:\/\/t\.lickd\.co\/\w+|https:\/\/lickd\.lnk\.to\/\w+)/;
  const extractedList = attribution.match(urlRegex) || [];
  const linkFireUrl = extractedList.length ? extractedList[0] : '';
  /**  */

  return `🎵 Music licensed from Lickd. The biggest mainstream and stock music platform for content creators.\n${track} by ${artist}, ${linkFireUrl} License ID: ${shortId}\nIf you want to use music from famous artists, try Lickd to get track credits and unlimited stock music: ${ATTRIBUTION_REFERRAL_URL}`;
};
